import {
  SAVE_EDIT_PROFILE_DATA,
  RESET_EDIT_PROFILE
} from '../../constants/actions';
import { deepCopy } from '../../assets/helpers/utils';

const initialState = {};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SAVE_EDIT_PROFILE_DATA:
      return deepCopy(action.data);
    case RESET_EDIT_PROFILE:
      return initialState;
    default:
      return state;
  }
}
